import React from "react";
import FButton from "@components/FButton";

import ContentRoundSelector from "./ContentRoundSelector";

interface UploadedContentHeaderProps {
  rounds: any[];
  selectedRound: number;
  onRoundChange: (value: number) => void;
  deliverable?: {
    name: string;
  };
  onAddNew?: () => void;
}

const UploadedContentHeader: React.FC<UploadedContentHeaderProps> = ({
  rounds,
  selectedRound,
  onRoundChange,
  deliverable,
  onAddNew,
}) => (
  <div className="flex sm:flex-row flex-col mb-4 items-start justify-between">
    <div className="max-w-[50%] lg:max-w-full mb-4">
      <h3 className="text-xl lg:text-2xl leading-[24px] text-dark truncate">
        {deliverable?.name ? `${deliverable.name} content` : "Uploaded content"}
      </h3>
    </div>
    <div className="flex items-center gap-2 lg:gap-4 lg:justify-end lg:w-full">
      <ContentRoundSelector
        rounds={rounds}
        selectedRound={selectedRound}
        onRoundChange={onRoundChange}
      />
      {/* Buttons */}
      <div className="flex items-center">
        {onAddNew ? (
          <FButton
            onClick={onAddNew}
            iconLeft={{
              name: "plus",
              size: 12,
              color: "#fff",
              className: "mr-1 -mt-1",
            }}
            primary
            className="whitespace-nowrap text-sm"
            label="Add Content"
          />
        ) : null}
      </div>
    </div>
  </div>
);

export default UploadedContentHeader;
